// extracted by mini-css-extract-plugin
export default {"subHeader":"SubHeader_subHeader__AsEwk","placeHolderShimmer":"SubHeader_placeHolderShimmer__bR3XR"};